import { getToggleName, DISABLED } from '~/feature-flags';

/**
 * Filters out results which are disabled via Unleash feature flags.
 * @param {Iterable} results
 * @param {Function} getFeatureToggle feature toggle getter. Undefined if Unleash not present.
 * @returns {Iterator}
 */
export default function* withFeatureFlags(results, getFeatureToggle) {
  for (const { component, result } of results) {
    const experiment = getToggleName(result.type);
    if (!(getFeatureToggle && getFeatureToggle(experiment)?.value === DISABLED)) {
      yield { component, result };
    }
  }
}
